import React from "react";

const Card = (props) => {
  const { value, suit, played, flipped, playAction } = props;

  const playFunc = () => {
    if (typeof playAction === "function") playAction();
  };

  return (
    <div
      onClick={playFunc}
      className={`hand__card card card--${suit} hand__card--${
        played ? "leave" : "flipped"
      } ${flipped ? "hidden" : ""}`}
    >
      <div className="card__face playerCards">
        <div data-value={value} data-suit={suit} className="card__value"></div>
        <div data-value={value} data-suit={suit} className="card__value"></div>
        <div className="card__suit">{suit}</div>
      </div>
      <div className="card__back"></div>
    </div>
  );
};

export default Card;
